import CountrySelect from "react-select-country-list";
import axios from "axios";
import { axiosInstance } from "./axiosConfig";
import { urlConstructor, END_POINTS } from "./constants";
import { generateExcel } from "./generateExcel";

export const getCountryList = () => {
  const countryData = CountrySelect().getData();
  const countryOptions = countryData.map((country) => country.label);
  countryOptions.unshift("Global");
  return countryOptions;
};

export const getServiceProviderData = async (reqData) => {
  try {
    const serviceResp = await axiosInstance.post(
      urlConstructor(END_POINTS.SERVICE_PROVIDER),
      reqData
    );
    return serviceResp.data;
  } catch (error) {
    return error.response ? error.response.data.message : "Network Error";
  }
};

export const getAdminList = async (reqData) => {
  const adminResp = await axiosInstance.post(
    urlConstructor(END_POINTS.ADMIN_LIST),
    reqData
  );
  return adminResp.data;
};

export const saveAdmin = async (adminData) => {
  try {
    const adminResp = await axiosInstance.post(
      urlConstructor(END_POINTS.ADMIN_LIST),
      adminData
    );
    return adminResp.data;
  } catch (error) {
    return error.response.data;
  }
};

export const deleteAdmin = async (adminData) => {
  const adminResp = await axiosInstance.post(
    urlConstructor(END_POINTS.ADMIN_LIST),
    adminData
  );
  return adminResp.data;
};

export const getServiceOfferingsList = async (reqData) => {
  const serviceResp = await axiosInstance.post(
    urlConstructor(END_POINTS.SERVICE_OFFERINGS),
    reqData
  );
  return serviceResp.data.responseData;
};

export const saveServiceOfferings = async (serviceOfferingData) => {
  try {
    const serviceOfferingResp = await axiosInstance.post(
      urlConstructor(END_POINTS.SERVICE_OFFERINGS),
      serviceOfferingData
    );
    return serviceOfferingResp.data;
  } catch (error) {
    return error.response.data;
  }
};

export const saveServiceProviders = async (serviceProviderData) => {
  try {
    const serviceProviderResp = await axiosInstance.post(
      urlConstructor(END_POINTS.SERVICE_PROVIDER),
      serviceProviderData
    );
    return serviceProviderResp.data;
  } catch (error) {
    return error.response.data;
  }
};

export const searchServiceProviders = async (serviceProviderQuery) => {
  try {
    const serviceProviderResp = await axiosInstance.post(
      urlConstructor(END_POINTS.SERVICE_PROVIDER),
      serviceProviderQuery
    );
    return serviceProviderResp.data;
  } catch (error) {
    return error.response.data;
  }
};

export const handleOtpRequest = async (otpRequest) => {
  try {
    const serviceProviderResp = await axiosInstance.post(
      urlConstructor(END_POINTS.SERVICE_PROVIDER),
      otpRequest
    );
    return serviceProviderResp.data;
  } catch (error) {
    return error.response.data;
  }
};

export const deleteServiceProviders = async (ServiceProviderData) => {
  const adminResp = await axiosInstance.post(
    urlConstructor(END_POINTS.SERVICE_PROVIDER),
    ServiceProviderData
  );
  return adminResp.data;
};

export const deleteServiceOfferings = async (serviceOfferingData) => {
  const adminResp = await axiosInstance.post(
    urlConstructor(END_POINTS.SERVICE_OFFERINGS),
    serviceOfferingData
  );
  return adminResp.data;
};

export const verifyEmailUrl = async (requestData) => {
  try {
    const verifyResp = await axiosInstance.post(
      urlConstructor(END_POINTS.SERVICE_PROVIDER),
      requestData
    );
    return verifyResp.data;
  } catch (error) {
    return error.response.data;
  }
};

const rearrangeKeysInArray = (dataArray, order) => {
  return dataArray.map((data) => {
    const reorderedObject = {};
    order.forEach((key) => {
      if (data.hasOwnProperty(key)) {
        reorderedObject[key] = data[key];
      }
    });
    return reorderedObject;
  });
};

export const exportToExcel = async () => {
  const serviceProviderData = await getServiceProviderData({
    operation: "downloadCsv",
    username: "kuranja3",
  });

  const desiredOrder = [
    "serviceProviderName",
    "serviceProviderURL",
    "requestId",
    "address",
    "country",
    "servicesProvided",
    "serviceCountries",
    "primaryName",
    "primaryEmail",
    "primaryContact",
    "secondaryName",
    "secondaryEmail",
    "secondaryContact",
    "createdOn",
    "modifiedOn",
  ];

  const responseData = rearrangeKeysInArray(
    serviceProviderData.responseData,
    desiredOrder
  );
  generateExcel(responseData);
};

export const getNPAToken = async () => {
  try {
    const CLIENT_BASIC_AUTH = btoa(
      `${process.env.REACT_APP_AUTH_KEY}:${process.env.REACT_APP_BASE_SECRET}`
    );
    const request = {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Basic ${CLIENT_BASIC_AUTH}`,
      },
      body: `grant_type=password&username=${process.env.REACT_APP_NPA_USER}&password=${process.env.REACT_APP_NPA_PASSWORD}`,
    };

    const response = await fetch(
      `${process.env.REACT_APP_AUTH_BASE_URL}/token`,
      request
    );

    if (response.status === 200) {
      const tokenData = await response.json();
      return tokenData.access_token;
    } else {
      return "Error in getting NPA access token!";
    }
  } catch (error) {
    if (error instanceof Error) {
      return error.message;
    } else {
      return error;
    }
  }
};

export const createEmailToken = async (ServiceProviderData) => {
  const tokenResp = await axiosInstance.post(
    urlConstructor(END_POINTS.SERVICE_PROVIDER),
    ServiceProviderData
  );
  return tokenResp.data;
};

export const sendEmail = async (subject, content, toRecipients) => {
  try {
    const accessToken = await getNPAToken();
    const response = await axios.post(
      process.env.REACT_APP_EMAIL_URL,
      {
        subject,
        toRecipients,
        body: {
          content,
          contentType: "html",
        },
      },
      {
        headers: {
          "X-Merck-APIKey": process.env.REACT_APP_EMAIL_API_KEY,
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.status;
  } catch (error) {
    return { success: false, message: `Unexpected server response ${error}` };
  }
};
